// Escritório, avaliador e transportadora só se cadastram vinculados a Pessoas (AF-3973, regra no
// domínio do recovery). Quem cadastra em Pessoas é o time de Cadastro (F&P), não o jurídico: a tela
// orienta a pedir o cadastro e trava o Salvar até o vínculo existir.
const PERSON_LINK_SUBJECT: Record<string, string> = {
    LAW_FIRM: 'do escritório',
    APPRAISER: 'do avaliador',
    CARRIER: 'da transportadora',
};

const BASIC_REGISTRATION_MESSAGE = 'Documento não encontrado no cadastro. Prossiga com o cadastro básico.';

export const requiresPersonLink = (beneficiaryType: string): boolean => beneficiaryType in PERSON_LINK_SUBJECT;

export const personLinkMessage = (beneficiaryType: string): string => {
    if (!requiresPersonLink(beneficiaryType)) return '';
    return `Solicite o cadastro ${PERSON_LINK_SUBJECT[beneficiaryType]} ao time de Cadastro (F&P). `
        + 'Depois que ele estiver em Pessoas, busque o CNPJ aqui para vincular.';
};

export const notFoundMessage = (beneficiaryType: string): string =>
    personLinkMessage(beneficiaryType) || BASIC_REGISTRATION_MESSAGE;

export const canSaveBeneficiary = (beneficiaryType: string, personId: string | undefined): boolean =>
    !requiresPersonLink(beneficiaryType) || !!personId;
